import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './Remainder.css';
import MedicinePill from "../../Assets/Images/medicinepill.png";
import Bloodtest from "../../Assets/Images/BloodPressureIcon.png"
import backIcon from "../../Assets/Images/Expand_left.png";
import TestResultForm from "../TestResult/TestResultForm";
import TestNotTaken from "../TestNotTaken/TestNotTaken";
import config from "../../Config"; // Assuming a config file for API_BASE_URL

const Remainder = () => {
    const navigate = useNavigate();
    const [showTestForm, setShowTestForm] = useState(false);
    const [showNotTaken, setShowNotTaken] = useState(false);
    const [currentTask, setCurrentTask] = useState(null);
    const [medicines, setMedicines] = useState([]);
    const [tests, setTests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Retrieve patientid from sessionStorage
    const patientid = sessionStorage.getItem("patientid");

    const handleTakenClick = (taskName) => {
        setShowTestForm(true);
        setShowNotTaken(false);
        setCurrentTask(taskName);
    };

    const handleNotTakenClick = (taskName) => {
        setShowNotTaken(true);
        setShowTestForm(false);
        setCurrentTask(taskName);
    };

    const handleClosePopup = () => {
        setShowTestForm(false);
        setShowNotTaken(false);
        setCurrentTask(null);
    };

    const getReminder = async () => {
        if (!patientid) {
            console.error("Patient ID is not available in sessionStorage");
            return;
        }
        try {
            const token = sessionStorage.getItem("authToken"); // Assuming you store the token in sessionStorage
            const response = await fetch(`${config.API_BASE_URL}/patient/reminder/${patientid}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`, // Add the token here
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (response.ok && data.status === 1) {
                setMedicines(data.data.medicines || []);
                setTests(data.data.tests || []);
            } else {
                setError("Failed to fetch reminders. Please try again later.");
            }
        } catch (error) {
            console.error('Error fetching reminders:', error);
            setError("An error occurred while fetching reminders.");
        } finally {
            setLoading(false); // Set loading to false after fetching
        }
    };

    useEffect(() => {
        getReminder();
    }, []);

    return (
        <div className="reminder-container">
        <header className="reminder-header">
            <button className="back-button" onClick={() => navigate('/home')} aria-label="Back to Home">
                <img src={backIcon} alt="Back" className="back-icon" />
            </button>
            <h2>Reminder</h2>
        </header>
    
        {loading ? (
            <div className="loading-message">Loading reminders...</div>
        ) : error ? (
            <div className="error-message">{error}</div>
        ) : (
            <section className="today-plan">
                <h3>Medicine Reminders</h3>
                {medicines.map((medicine) => (
                    <div className="plan-card" key={medicine.id}>
                        <div className="plan-details">
                            <div className="medicine">
                                <img src={MedicinePill} alt="Pill" />
                                <div>
                                    <h3>{medicine.medicine_name}</h3>
                                    <p>{medicine.instruction || "No instruction available"}</p>
                                </div>
                            </div>
                            <div className="responses">
                                <button className="not-taken" onClick={() => handleNotTakenClick(medicine.medicine_name)}>
                                    Not Taken
                                </button>
                                <button className="taken" onClick={() => handleTakenClick(medicine.medicine_name)}>
                                    Taken
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
                {tests.map((test) => (
                    <div className="plan-card" key={test.id}>
                        <div className="plan-details">
                            <div className="medicine">
                                <img src={Bloodtest} alt="Test" />
                                <div>
                                    <h3>{test.test_name}</h3>
                                    <p>{test.instruction || "No instruction available"} - {test.reminder}</p>
                                </div>
                            </div>
                            <div className="responses">
                                <button className="not-taken" onClick={() => handleNotTakenClick(test.test_name)}>
                                    Not Taken
                                </button>
                                <button className="taken" onClick={() => handleTakenClick(test.test_name)}>
                                    Taken
                                </button>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Inline Popup Modal without Close Icon */}
            {(showTestForm || showNotTaken) && (
                <div className="modals-overlays" onClick={handleClosePopup}>
                    <div className="modals-contents" onClick={(e) => e.stopPropagation()}>
                        {showTestForm && <TestResultForm taskName={currentTask} />}
                        {showNotTaken && <TestNotTaken taskName={currentTask} />}
                    </div>
                </div>
            )}
            </section>
        )}
    </div>
        
    );
};

export default Remainder;